<template>
	<div>
		<div class="header px-0">
			<div>
				Edit Tsm Number
			</div>
		</div>
		<v-btn
			fab
			flat
			class="top-right-align pa-0 ma-0 pt-1"
			@click="closeModal"
		>
			<v-icon>close</v-icon>
		</v-btn>
		<div class="pa-4">
			<v-text-field
				type="text"
				label="Phone Number"
				v-model="tsmNumber"
				prepend-icon="phone"
				prefix="+91"
				placeholder="Enter Phone Number"
				class="text-field-wrapper pt-4"
				:rules="[requiredRule, onlyDigitRule]"
				maxlength="10"
			></v-text-field>
			<div>
				<v-btn
					class="ma-0 mt-3 pa-4 white--text full-width btn"
					:color="themeInputColor"
					:loading="editTsmLoading"
					@click="editTsmNumber"
					:disabled="/\D/g.test(tsmNumber) || tsmNumber.length !== 10"
					>Submit</v-btn
				>
			</div>
		</div>
	</div>
</template>
<script>
import * as utils from "@/utils";
import { mapState } from "vuex";
import { EDIT_TSM_NUMBER } from "@/store/action-types";
export default {
	name: "EditTsmNumber",
	props: ["themeInputColor", "model"],
	data() {
		return {
			tsmNumber: null,
			editTsmLoading: false,
			requiredRule: v => utils._requiredRule(v),
			onlyDigitRule: v => utils._onlyDigitsRule(v)
		};
	},
	computed: {
		...mapState({
			userId: state => state.auth.USERID
		})
	},
	methods: {
		editTsmNumber() {
			if (!this.editTsmLoading) {
				this.editTsmLoading = true;
				let payload = {
					retailerDetails: [
						{
							userId: this.userId,
							tsmNumber: parseInt("91" + this.tsmNumber, 10)
						}
					]
				};
				this.$store
					.dispatch(EDIT_TSM_NUMBER.dispatch, payload)
					.then(() => {
						this.editTsmLoading = false;
						this.$emit("fetchJeet11WalletDetails");
						this.closeModal();
					})
					.catch(err => {
						console.error(err);
						this.editTsmLoading = false;
					});
			}
		},
		closeModal() {
			this.$emit("CLOSE_MODAL", this.model);
		}
	}
};
</script>
<style scoped>
.header {
	border-radius: 16px 16px 0 0;
	background-color: #edf0f7;
	color: #233b5d;
	font-weight: 500;
	font-size: 20px;
	line-height: 21px;
	padding: 1em;
	text-align: center;
	letter-spacing: 0.004em;
	text-transform: capitalize;
}
</style>
